//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { Scrim } from '@legacy-components/nav3/navigation-menus/Scrim';
import { TOP_NAV_BAR_HEIGHT } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { CommerceNav } from '@legacy-components/nav3/navigation-menus/menu-dropdown-items/CommerceNav';
import { ContentNav } from '@legacy-components/nav3/navigation-menus/menu-dropdown-items/ContentNav';
import { CreatorsNav } from '@legacy-components/nav3/navigation-menus/menu-dropdown-items/CreatorsNav';
import { PublishingNav } from '@legacy-components/nav3/navigation-menus/menu-dropdown-items/PublishingNav';
import { CampaignsNav } from '@legacy-components/nav3/navigation-menus/menu-items/CampaignsNav';
import { HomeNav } from '@legacy-components/nav3/navigation-menus/menu-items/HomeNav';
import { InboxNav } from '@legacy-components/nav3/navigation-menus/menu-items/InboxNav';
import { InsightsNav } from '@legacy-components/nav3/navigation-menus/menu-items/InsightsNav';
import { ListeningNav } from '@legacy-components/nav3/navigation-menus/menu-items/ListeningNav';
import { SamplingNav } from '@legacy-components/nav3/navigation-menus/menu-items/SamplingNav';
import makeAngularReactController from '@react-bridge/angular-react-widget';
import {
  getIsShareV2Vendor,
  getIsSyndicationClient,
} from '@redux/selectors/getSessionInfo';
import { getIsBazaarvoiceNetworkSyndicationFrontendEnabled } from '@uia/rights/selectors/getUIARights';

export const NavMenuTabs = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isBazaarvoiceSyndicationEnabled = useSelector(
    getIsBazaarvoiceNetworkSyndicationFrontendEnabled,
  );

  const isSyndicationClient = useSelector(getIsSyndicationClient);
  const isShareV2VendorClient = useSelector(getIsShareV2Vendor);

  const isLegacySyndicationOrConnectClient =
    (isSyndicationClient || isShareV2VendorClient) &&
    !isBazaarvoiceSyndicationEnabled;

  if (isLegacySyndicationOrConnectClient) {
    return null;
  }

  return (
    <NavMenu>
      <HomeNav />
      <CreatorsNav setIsMenuOpen={setIsMenuOpen} />
      <SamplingNav />
      <CampaignsNav />
      <ContentNav setIsMenuOpen={setIsMenuOpen} />
      <PublishingNav setIsMenuOpen={setIsMenuOpen} />
      <InboxNav />
      <CommerceNav setIsMenuOpen={setIsMenuOpen} />
      <ListeningNav />
      <InsightsNav />
      <Scrim isOpen={isMenuOpen} />
    </NavMenu>
  );
};

const NavMenu = styled.div(
  ({ theme }) => `
    display: inline-flex;
    align-items: center;
    height: ${TOP_NAV_BAR_HEIGHT};
    font-weight: ${theme.fontWeights.semiBold};
  `,
);

angular.module('curalate').component('navMenuTabs', {
  controller: makeAngularReactController(<NavMenuTabs />),
});
